const ProjectStages = {
  PROJECT_CREATED: {
    number: 0,
    name: 'Project created',
    nextStep: '',
  },
  QUESTIONNAIRE_AND_WRITER_MATCH: {
    number: 1,
    name: 'Questionnaire and writer match',
    nextStep: 'Review questionnaire feedback',
  },
  INTERVIEWS_SCHEDULING: {
    number: 2,
    name: 'Interview scheduling',
    nextStep: 'Schedule interviews',
  },
  INTERVIEW_STAGE: {
    number: 3,
    name: 'Interview stage',
    nextStep: 'Conduct all interview hours',
  },
  CREATING_OUTLINE: {
    number: 4,
    name: 'Creating outline',
    nextStep: 'Send outline to editor',
  },
  OUTLINE_APPROVAL_BY_EDITOR: {
    number: 5,
    name: 'Outline approval by Editor',
    nextStep: 'Agree outline with editor',
  },
  OUTLINE_APPROVAL_BY_CUSTOMER: {
    number: 6,
    name: 'Outline approval by Customer',
    nextStep: 'Creating sample',
  },
  CREATING_SAMPLE: {
    number: 7,
    name: 'Creating sample',
    nextStep: 'Agree sample with editor',
  },
  SAMPLE_APPROVAL_BY_EDITOR: {
    number: 8,
    name: 'Sample approval by Editor',
    nextStep: 'Agree sample with customer',
  },
  SAMPLE_APPROVAL_BY_CUSTOMER: {
    number: 9,
    name: 'Sample approval by Customer',
    nextStep: 'Creating draft',
  },
  CREATING_DRAFT: {
    number: 10,
    name: 'Content team creating draft',
    nextStep: 'Send draft to writer',
  },
  DRAFT_APPROVAL_BY_WRITER: {
    number: 11,
    name: 'Awaiting Writer edits',
    nextStep: 'Send draft to editor',
  },
  DRAFT_APPROVAL_BY_EDITOR: {
    number: 12,
    name: 'Awaiting Draft approval by Editor',
    nextStep: 'Agree draft with Developmental Editor',
  },
  DRAFT_DEVELOPMENTAL_EDITING: {
    number: 13,
    name: 'Draft developmental editing',
    nextStep: '',
  },
  DRAFT_PRO_PROOFREADING: {
    number: 14,
    name: 'Draft Pro proofreading',
    nextStep: '',
  },
  DRAFT_APPROVAL_BY_CUSTOMER: {
    number: 15,
    name: 'Awaiting Draft approval by Customer',
    nextStep: '',
  },
  FINAL_PROOF_CREATION: {
    number: 16,
    name: 'Final proof creation',
    nextStep: '',
  },
  FINAL_PROOF_APPROVAL_BY_CUSTOMER: {
    number: 17,
    name: 'Final proof approval by Customer',
    nextStep: '',
  },
  SEND_TO_PRINTER: {
    number: 18,
    name: 'Send to printer',
    nextStep: '',
  },
  DELIVERY: {
    number: 19,
    name: 'Delivery',
    nextStep: '',
  },
  PROJECT_ARCHIVED: {
    number: 20,
    nextStep: '',
    name: 'Completed / Archived',
  },
};

module.exports = ProjectStages;
